module.exports = {
      id: "card-usage",
      viewBox: "0 0 22 18",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#card",
      toString: function () {
        return this.url;
      }
    }